import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewPlazaPage } from './merchant-overview-plaza';

@NgModule({
  declarations: [
    MerchantOverviewPlazaPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewPlazaPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewPlazaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-plaza/merchant-overview-plaza.module.ts